<template>
  <div>
    <ed-cid :intCidId="0" :key="$root.$session.versao"/>
  </div>
</template>

<script>
import EdCid from "@/components/cadastro/cid/editar";

export default {
  name: "pageCadastroEmpresa",
  props: {},
  components: {EdCid },
  mounted() {},
  created() {},
  data() {
    return {
    };
  },
  methods: {
  
  },
};
</script>